import { useMediaQuery } from '@chakra-ui/react';

const useIsMobileScreen = () => {
  const [isMobile] = useMediaQuery('(max-width: 768px)');
  return isMobile;
};
export default useIsMobileScreen;
